/**
 * Custom hook that dynamically switches the favicon based on registration status.
 *
 * @param {Object} registrationStatus - An object containing registration status flags
 * @param {string} registrationStatus.EDL - The EDL service status (e.g., 'active', 'inactive')
 * @param {string} registrationStatus.Imperva - The Imperva service status (e.g., 'active', 'inactive')
 * @param {string} registrationStatus.Akamai - The Akamai service status (e.g., 'active', 'inactive')
 *
 * @description
 * Updates the favicon displayed in the browser tab:
 * - Displays 'unlock.svg' when all three services (EDL, Imperva, and Akamai) are active
 * - Displays 'lock.svg' when any service is not active
 *
 * @example
 * useFaviconSwitcher({
 *   EDL: 'active',
 *   Imperva: 'active',
 *   Akamai: 'active'
 * })
 */

import { useEffect } from 'react'
import logo from '../../assets/lock.svg'
import unlockLogo from '../../assets/unlock.svg'

export default function useFaviconSwitcher(registrationStatus) {
  useEffect(() => {
    const link = document.querySelector("link[rel='icon']")

    if (
      registrationStatus.EDL === 'active' &&
      registrationStatus.Imperva === 'active' &&
      registrationStatus.Akamai === 'active'
    ) {
      link.href = unlockLogo
    } else {
      link.href = logo
    }
  }, [registrationStatus.EDL, registrationStatus.Imperva, registrationStatus.Akamai])
}
